import React from 'react';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { useWindowSize } from '../../../../utils/hooks';
import classes from './TimesheetHeader.module.scss';
import { responsiveSizeTimesheet, timesheetsStatuses } from '../../../../utils/constants';
import InfoSign from '../../../common/InfoSign/InfoSign';
import KeyValueLabel from '../../../common/labels/KeyValueLabel/KeyValueLabel';
import StatusLabel from '../../../common/labels/StatusLabel/StatusLabel';
import InfoIcon from '../../../common/Icons/InfoIcon';
import colors from '../../../../scss/colors';
import { generalEnums } from '../../../../utils/enums';

export const InfoSignRenderComponent = ({timesheet, isApprover}) => {
  const { t } = useTranslation();
  const size = useWindowSize();

  return (
    <InfoSign text={isApprover && `${timesheet?.user?.FirstName} ${timesheet?.user?.LastName}`} icon={<InfoIcon />}>
      <Box
        sx={{
          width: 'max-content',
          padding: '32px 24px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
        gap: '14px',
        backgroundColor: colors.PAGE_BACKGROUND,
        boxShadow: size.width > responsiveSizeTimesheet ? '0 4px 4px rgba(0, 0, 0, 0.25)' : 'none',
        borderRadius: '20px'
      }}
    >
      <KeyValueLabel
        label={isApprover ? t('dashboard.timesheet.header.contractor') : t('dashboard.timesheet.header.client')}
        value={isApprover ? `${timesheet?.user?.FirstName} ${timesheet?.user?.LastName}` : timesheet?.client}
      />
      <KeyValueLabel label={t('dashboard.timesheet.header.jobtitle')} value={timesheet?.placement} />
      <KeyValueLabel
        oneLine
        label={t('dashboard.timesheet.header.date')}
        value={dayjs(timesheet?.createdDate).format(generalEnums.DATEWITH_MMM)}
      />
      <KeyValueLabel label={t('dashboard.timesheet.header.order')} value={timesheet?.po || '-'} />
      <KeyValueLabel label={t('dashboard.timesheet.header.recordn')} value={timesheet?.recordNo} />
    </Box>
  </InfoSign>
)}

export default function TimesheetsHeader({ timesheet, isApprover, created }) {
  const { t } = useTranslation();
  const size = useWindowSize();

  return size.width < responsiveSizeTimesheet && (
    <div className={classes.container}>
      <div className={classes.mobileClientPlacement}>
        <span className={classes.clientName}>
          {isApprover ? `${timesheet?.User?.FirstName} ${timesheet?.User?.LastName}` : timesheet?.ClientName},&nbsp;
        </span>
        <span className={classes.placement}>{timesheet?.Placement}</span>
      </div>
    </div>
  )
}
